import { getUserFromStorage } from "@/utils/user-store.util";

const author = {
  mounted: (el, bindingId) => {
    if (!bindingId.value) return;
    const user = getUserFromStorage();
    if (user.id !== bindingId.value) {
      el.style.display = "none";
      el.setAttribute("aria-hidden", true)
    }
  },
};
const role = {
  mounted: (el, bindingRoles) => {
    if (!Array.isArray(bindingRoles.value)) return;
    const user = getUserFromStorage();

    const hasAllowedRole = bindingRoles.value.some(
      (role) => role === user.role
    );

    if (!hasAllowedRole) {
      el.style.display = "none";
      el.setAttribute("aria-hidden", true)
    }
  },
};
export { author, role };
